var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 265 277",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    fill: "#05a81f",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M168 101l90 0c4,0 7,3 7,7l0 25c0,4 -3,7 -7,7l-90 0 0 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7 101l91 0 0 39 -91 0c-4,0 -7,-3 -7,-7l0 -25c0,-4 3,-7 7,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M113 269l0 -170c0,-4 4,-7 8,-7l24 0c4,0 7,3 7,7l0 170c0,4 -3,8 -7,8l-24 0c-4,0 -8,-3 -8,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M248 155l0 97c0,10 -8,18 -18,18l-62 0 0 -115 80 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M98 155l0 115 -63 0c-9,0 -17,-8 -17,-18l0 -97 80 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M111 86c-40,7 -76,2 -107,-13 3,-3 6,-6 9,-9 0,-4 0,-9 0,-13 17,11 55,33 98,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M199 10c13,13 13,35 0,49 -13,12 -45,12 -64,14 3,-18 2,-50 15,-63 14,-13 35,-13 49,0zm-42 42c12,-1 24,-3 28,-7 6,-6 6,-15 0,-21 -6,-6 -15,-6 -21,0 -4,3 -6,16 -7,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M76 23c-11,10 -11,28 0,39 10,10 36,10 51,11 -2,-15 -1,-40 -12,-50 -11,-11 -28,-11 -39,0zm34 33c-10,-1 -20,-2 -23,-5 -5,-5 -5,-13 0,-18 5,-4 13,-4 17,0 3,3 5,14 6,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M155 86c39,7 75,2 106,-13 -3,-3 -6,-6 -9,-9 0,-4 1,-9 1,-13 -17,11 -56,33 -98,35z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2c1436cb5ab1590e75c8d5f0c0c62c50.svg";
export { ForwardRef as ReactComponent };